import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';
import { apiRequest } from '../lib/api';

export type TimelineEventRecord = {
  id: string;
  type: string;
  label: string;
  description: string | null;
  ref_table: string | null;
  ref_id: string | null;
  created_at: string;
};

async function fetchTimelineEvents(
  clientId: string,
  accessToken: string | null | undefined,
) {
  return apiRequest<TimelineEventRecord[]>(
    `/api/clients/${clientId}/timeline`,
    { method: 'GET' },
    accessToken,
  );
}

export function useClientTimeline(clientId: string) {
  const { session } = useAuth();

  return useQuery<TimelineEventRecord[]>({
    queryKey: ['timeline', clientId],
    enabled: Boolean(clientId && session),
    queryFn: () => fetchTimelineEvents(clientId, session?.access_token),
  });
}

export function useInvalidateTimeline(clientId: string) {
  const queryClient = useQueryClient();
  return () =>
    queryClient.invalidateQueries({
      queryKey: ['timeline', clientId],
    });
}
